import { CatalogGiftReceivedStore, CatalogGiftArticleData } from '../../models/loyalty-catalog-gift-received-store.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';

@Injectable()
export class LoyaltyCatalogGiftReceivedStoreAllService {
  baseUrl = HttpClientService.BASE_MS_LOYALTY;
  userId: string;

  constructor(private http: HttpClientService) { }

  /**
    * Tramite metodo GET, restituisce la lista dei Premi ricevuti, e nell'eventualità assegnati, da uno store.
    * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
   list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<CatalogGiftReceivedStore>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/reservation/gift_head_rec?user_id=${this.userId}&param_all=false` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-catalog-gift-received-store-all.service.ts